import { render, staticRenderFns } from "./AppVersionUpgradeLogList.vue?vue&type=template&id=62728bdc&scoped=true&"
import script from "./AppVersionUpgradeLogList.vue?vue&type=script&lang=js&"
export * from "./AppVersionUpgradeLogList.vue?vue&type=script&lang=js&"
import style0 from "./AppVersionUpgradeLogList.vue?vue&type=style&index=0&id=62728bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62728bdc",
  null
  
)

export default component.exports